import React from "react";
import Modal from "react-bootstrap/Modal";
import { X } from "react-bootstrap-icons";
import Spinner from "react-bootstrap/Spinner";
import "./popup.styles.scss";

const Popup = (props) => {
  const handleCloseComponent = (message) => {
    //   calls closeComponent method from props to close the modal also passes the success message
    props.closeComponent(message);
  };

  const handleSubmitComponent = (event) => {
    // handles submit component
    props.saveComponent(event);
  };

  return (
    <Modal
      show={true}
      onHide={handleCloseComponent}
      backdrop="static"
      keyboard={false}
      className={"popup-modal-layout" + (props.popupBig ? "" : " small")}
    >
      <Modal.Header className="popup-modal-header">
        {props.backButton ? (
          <button
            onClick={handleCloseComponent}
            className="popup-header-back-button"
          >
            <svg
              xmlns="http://www.w3.org/2000/svg"
              viewBox="0 0 16 16"
              width="16"
              height="16"
              fill="black"
              stroke="black"
              strokeWidth="1.2"
            >
              <path
                fillRule="evenodd"
                d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0z"
              ></path>
            </svg>
          </button>
        ) : null}
        {props.dualTitle ? (
          <div className="popup-modal-title-layout">
            <Modal.Title className="popup-modal-title-blue-header">
              {props.modalTitle}
            </Modal.Title>
            <Modal.Title className="popup-modal-title-small-header">
              {props.modalTitle2}
            </Modal.Title>
          </div>
        ) : (
          <Modal.Title className="popup-modal-title">
            {props.modalTitle}
          </Modal.Title>
        )}

        <button
          className="popup-button-align popup-modal-cross-button"
          onClick={handleCloseComponent}
        >
          <X size={34} />
        </button>
      </Modal.Header>
      <Modal.Body className="popup-modal-body">{props.children}</Modal.Body>
      {props.cancelButtonVisible || props.saveButtonVisible ? (
        <Modal.Footer className="popup-modal-footer">
          {props.cancelButtonVisible ? (
            <button
              className="popup-button-align popup-button-standard popup-modal-cancel-button"
              onClick={handleCloseComponent}
            >
              Cancel
            </button>
          ) : null}
          {props.saveButtonVisible ? (
            <button
              disabled={props.saveButtonDisable}
              className={
                "popup-button-align popup-button-standard popup-modal-save-button " +
                (props.saveButtonDisable
                  ? "popup-modal-save-button-disabled"
                  : "")
              }
              onClick={(event) => handleSubmitComponent(event)}
            >
              {props.saveButtonText}
            </button>
          ) : null}
          {props.spinnerVisible ? (
            <Spinner className="popup-spinner-animation" animation="border" />
          ) : null}
        </Modal.Footer>
      ) : null}
    </Modal>
  );
};
export default Popup;
